import React          from 'react';
import { FieldArray } from 'redux-form';

import DropZoneField from './base/DropZoneField';

export const RenderDropZone = ({ ...props }) => (
  <FieldArray
    component={DropZoneField}
    type={'file'}
    {...props}
  />
);